module.exports = __webpack_public_path__ + "img/social-media.ae004a58.svg";